import type {SessionService, SessionContact, HostingContact} from '../session/domain/sessionProtocol'

export type SessionOperation = keyof SessionService
export type InvokeSession = (operation: SessionOperation, payload: unknown) => Promise<{data: unknown}>

export function createSessionService(invoke: InvokeSession): SessionService {
  async function call<T>(operation: SessionOperation, payload: unknown): Promise<T> {
    const response = await invoke(operation, payload)
    return response.data as T
  }
  return {
    getActiveSession: () => call<SessionContact>('getActiveSession', {}),
    createHostedSession: (schedule, timer) => call<HostingContact>('createHostedSession', {schedule, timer}),
    publishSessionState: request => call<SessionContact>('publishSessionState', request),
    renewSessionHost: credential => call<SessionContact>('renewSessionHost', {credential}),
    resumeSessionHosting: (sessionId, expectedGeneration) => call<HostingContact>('resumeSessionHosting', {sessionId, ...(expectedGeneration === undefined ? {} : {expectedGeneration})}),
    deleteHostedSession: credential => call<void>('deleteHostedSession', {credential}),
    retireLegacySessions: () => call<void>('retireLegacySessions', {}),
  }
}
